import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody} from "reactstrap";
import { httpGet } from "../../../common/petitions";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import reportes from './model.json';
import "../tables.scss";
import "../Puestos.scss";
import DataLoader from "../../../components/tableData";
import { useNavigate } from 'react-router-dom';

const UnidadesResumenes = () => {

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet('/unidades/historicos',navigate)
      const jsonData = { "columns": reportes.unidades, "rows": rowsData }
      setData(jsonData);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  

  useEffect(() => {
    fetchData();
  }, []);

  const options = {
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };



  document.title = "Unidades - Reportes generales - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Unidades" title="Reportes generales"  />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                <h3>
                    Reporte unidades por Categoria
                  </h3>
                  <DataLoader 
                    isLoading={isLoading} 
                    data={data} 
                    options={options} 
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
     
    </React.Fragment>
  );
};

export default UnidadesResumenes;
